import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "./auth";


const ProtectedRoute = ({ element }) => {
    const { isAuthenticated, user, isLoading } = useContext(AuthContext);
    if (isLoading) {
      return 
    }
    const isAdmin = user && (user.is_staff || user.is_superuser)
    return isAuthenticated && isAdmin ? element : <Navigate to="/login" />;
  };

export default ProtectedRoute;
